import styled from "styled-components";

export const PromoImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: top;
  border-radius: ${({ theme }) => theme.radii[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    height: 340px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    height: 240px;
  }
`;

export const Promo = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[6]};
  margin: ${({ theme }) => `0 ${theme.space[4]} 4rem ${theme.space[4]}`};
  padding: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.white4};
  border-radius: ${({ theme }) => theme.radii[2]};
  border: ${({ theme }) => theme.borders[2]};
  border-radius: ${({ theme }) => theme.radii[2]};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    flex-direction: row;
    padding: 2rem;
    text-align: start;
  }
`;

export const ImageFrame = styled.div`
  width: 100%;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: linear-gradient(
      to top,
      rgba(28, 34, 45, 1) 10%,
      rgba(19, 25, 36, 0.15) 84%,
      transparent 100%
    );
  }
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    flex: 0 0 35%;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[1]};
`;

export const TextButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 55%;
  gap: ${({ theme }) => theme.space[3]};
`;

export const PromoHeading = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes[6]};
  font-family: ${({ theme }) => theme.fonts.impact};
`;

export const PromoText = styled.p`
  color: ${({ theme }) => theme.colors.white};
`;
